// components/MedicationLog.tsx
import React from 'react';
import { MedicationLogEntry } from '../utils/asthmaTypes';
import './MedicationLog.scss';

interface MedicationLogProps {
  medicationLog: MedicationLogEntry[];
}

export const MedicationLog: React.FC<MedicationLogProps> = ({ medicationLog }) => {
  if (!medicationLog.length) return null;

  return (
    <div className="asthma-wrapper">
    <div className="medication-log-container" dir="rtl">
      <div className="medication-log-header">
        <span className="medication-log-title">יומן מתן תרופות:</span>
      </div>
      
      <ul className="medication-log-list">
        {medicationLog.map((entry, index) => (
          <li key={index} className="medication-log-item">
            {/* the time of the medication */}
            <span className="medication-log-time">
              {entry.time.toLocaleTimeString('he-IL', {
                hour: '2-digit',
                minute: '2-digit',
              })}
            </span>
            <span className="medication-log-separator">: </span>
            
            {/* medication log */}
            <span className="medication-log-text">
              {entry.medications.join(', ')}
            </span>
          </li>
        ))}
      </ul>
    </div>
    </div>
  );
};